export const HTML_TAG_NAME_INPUT: string = 'input';
export const HTML_TAG_NAME_TEXTAREA: string = 'textarea';
export const HTML_TAG_NAME_BUTTON: string = 'button';
export const HTML_TAG_NAME_ANCHOR: string = 'a';
export const HTML_TAG_NAME_SVG: string = 'svg';
export const HTML_TAG_NAME_SVG_PATH: string = 'path';
export const HTML_TAG_NAME_SPAN: string = 'span';
export const HTML_TAG_NAME_HEADER: string = 'h1';
export const HTML_TAG_NAME_SUBHEADER: string = 'h2';
export const HTML_TAG_NAME_MAIN: string = 'main';
export const HTML_TAG_NAME_LIST: string = 'ul';
export const HTML_TAG_NAME_LIST_ITEM: string = 'li';
export const HTML_TAG_NAME_DIV: string = 'div';
export const HTML_TAG_NAME_IMG: string = 'img';
